// @ts-nocheck

import React from 'react';

import PageSelectTab from '../components/PageSelectTab';
import GridsHistoryBackButtonDesktop from '../modules/grids/components/menu/GridsHistoryBackButtonDesktop';
import GridsHistoryMenuDesktop from '../modules/grids/components/menu/GridsHistoryMenuDesktop';
import GridsPublicMenuDesktop from '../modules/grids/components/menu/GridsPublicMenuDesktop';
import GridsMenuDesktopContainer from '../modules/grids/containers/GridsMenuDesktopContainer';
import { RoutePatterns } from '../types/routes';

/**
 * Regroups all the necessary routes for the grids section
 */
const routes = [
  {
    pattern: RoutePatterns.GRID_HISTORY,
    Menu: GridsHistoryMenuDesktop,
    Tab: () => <PageSelectTab tab="grids" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.GRID_HISTORY_DETAIL,
    Menu: GridsHistoryBackButtonDesktop,
    Tab: () => <PageSelectTab tab="grids" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.GRID_PUBLIC,
    Menu: GridsPublicMenuDesktop,
    Tab: () => <PageSelectTab tab="grids" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.POOL,
    Menu: GridsMenuDesktopContainer,
    Tab: () => <PageSelectTab tab="grids" />,
  },
];

export default routes;
